import { ConfigurationService } from '../../../../../../../../services/configuration.service';
import type { ITripLeg } from '../../../../../../../../models/trip-leg.model';
import DeviceHelper, { DeviceType } from '../../../../../../../../helpers/device.helper';
import { TranslationService } from '../../../../../../../../services/translation.service';

function BussOnDemand({ tripLeg }: { tripLeg: ITripLeg }) {
  // === VARIABLES ===
  const deviceType = DeviceHelper.getDeviceType();
  const readMorePageUrl = ConfigurationService.get('travelplanner.linkToBussOnDemandReadMore');

  // === HELPERS ===
  function getOpenAppUrl(): string {
    if (deviceType === DeviceType.Android) {
      return tripLeg.padamUrls?.android ?? '';
    }
    if (deviceType === DeviceType.iOS) {
      return tripLeg.padamUrls?.ios ?? '';
    }
    return '';
  }

  // === EVENT HANDLERS ===
  function handleOpenAppButtonClick() {
    // If the app is not installed, the custom URL will do nothing.
    // To handle this, you can try to open the app URL, and then fall back to a website URL if the app does not open:
    window.location.href = getOpenAppUrl();
    setTimeout(() => {
      window.location.href = readMorePageUrl!;
    }, 500);
  }

  return (
    <div className="p-3 bg-blue rounded">
      <div className="last-child-margin-bottom-none">
        <div className="h3">{TranslationService.get('travelplanner.bussondemandheadingtext')}</div>
        <p>{TranslationService.get('travelplanner.bussondemandinformationtext')}</p>
        {deviceType === DeviceType.Desktop && <p>{TranslationService.get('travelplanner.bussondemanddesktopinformationtext')}</p>}
        {(deviceType === DeviceType.iOS || deviceType === DeviceType.Android) && (
          <p className="d-grid">
            <button className="btn btn-primary" onClick={handleOpenAppButtonClick}>
              {TranslationService.get('travelplanner.bussondemandbookinappbuttontext')}
            </button>
          </p>
        )}
        {readMorePageUrl && (
          <p>
            <a href={readMorePageUrl}>{TranslationService.get('travelplanner.bussondemandpagelinktext')}</a>
          </p>
        )}
      </div>
    </div>
  );
}

export default BussOnDemand;
